var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCartOutlined = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#333",
  clipPath: "url(#cart-outlined_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m4.019 7.224-.82-4.414h9.533999999999999l-1.186 4.485c-.12.451-.54.776-1.034.776H5.07c-.524 0-.96-.363-1.05-.847ZM2.753.517H.84L.834.5H2.68q.043 0 .07.005zM.838.46v.001ZM4.28 10.714c0-.431.351-.785.791-.786a.79.79 0 0 1 .793.787.79.79 0 0 1-.792.785.79.79 0 0 1-.792-.786ZM9.449 10.715c-.001-.43.35-.785.791-.787a.79.79 0 0 1 .793.787.79.79 0 0 1-.792.785.79.79 0 0 1-.792-.785Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cart-outlined_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.333 0h12.923v12H.333z"
})))));
export default SvgCartOutlined;